/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Embed_CopyInputs */

const en_admin_embed_copy = /** @type {(inputs: Admin_Embed_CopyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Copy code`)
};

const de_admin_embed_copy = /** @type {(inputs: Admin_Embed_CopyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Code kopieren`)
};

/**
* | output |
* | --- |
* | "Copy code" |
*
* @param {Admin_Embed_CopyInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const admin_embed_copy = /** @type {((inputs?: Admin_Embed_CopyInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Embed_CopyInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_admin_embed_copy(inputs)
	return en_admin_embed_copy(inputs)
});